module.exports = __webpack_public_path__ + "af71153c15ef29512fe677a80f0d189b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/gears5/bunker.png
// module id = 1064
// module chunks = 0